import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'None' },
    { value: 1, label: 'Student Medical' },
    { value: 2, label: 'Student Sensitive' },
  ],
});
